<template>
  <transition name="fade">
    <b-overlay
      :show="loading"
      rounded="sm"
      variant="transparent"
      opacity="1"
      blur="2px"
    >
      <b-container fluid v-if="influencer">
        <b-row>
          <b-col cols="4" md="3" lg="2" class="p-0 pt-md-4 pr-md-5 mb-3">
            <div
              class="p-1 border border-1 rounded-circle cursor"
              :style="
                `border-color:` + influencer.avatar_border_hex + ` !important`
              "
            >
              <b-link
                :to="
                  `/influencer/` +
                  influencer.influencer_uid +
                  `/` +
                  influencer.username
                "
              >
                <div
                  class="rounded-circle"
                  :style="
                    `padding: 49%; background:  url(` +
                    influencer.profile_photo_url +
                    `) center/cover;`
                  "
                />
              </b-link>
            </div>
          </b-col>
          <b-col cols="12" md="9" lg="10" align-self="center" class="m-0">
            <b-row>
              <b-col>
                <h1 class="font-weight-bold overflow-hidden m-0">
                  <span v-text="influencer.full_name" />
                </h1>
                <small class="grey-light">
                  <small>{{ `@` + influencer.username }}</small>
                </small>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-if="!vip_subscription && !vello_subscription">
                <p class="m-0 pt-4 text-grey">No subscriptions found</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col v-if="vip_subscription" cols="12" class="mt-4">
            <h5>VIP Subscription</h5>
            <div class="d-inline-block text-center mt-2 px-4">
              <label class="m-0">
                <small class="d-inline-block font-weight-bold align-top mt-2">
                  {{ default_currency.symbol }}
                </small>
                <h2 class="d-inline-block font-weight-bold m-0">
                  {{ vip_amount }}
                </h2>
              </label>
              <p class="m-0 mb-n2">
                <small v-if="isVipMonthly">Per Month</small>
                <small v-else>Per Year</small>
              </p>
            </div>
            <p class="text-left pt-2">
              <small class="text-grey">
                <span v-if="is_vip_canceled">
                  Valid until:
                  {{ convertDate(vip_subscription.billing_date) }}
                </span>
                <span v-else>
                  {{ vip_billing }}
                </span>
              </small>
            </p>
            <p
              class="mt-4 border-bottom border-black border-8 pb-3 px-3 mx-n3"
              v-if="!is_vip_canceled"
              @click="showConfirmBox('VIP')"
            >
              <b-link href="javascript:;">
                Unsubscribe
                <b-img
                  class="float-right mr-2 mt-1"
                  src="~@/assets/img/open.svg"
                />
              </b-link>
            </p>
          </b-col>

          <b-col v-if="vello_subscription" cols="12" class="mt-4">
            <h5>Vello Subscription</h5>
            <div class="d-inline-block text-center mt-2">
              <div class="d-inline-block pl-0 pr-4">
                <label class="m-0">
                  <h2 class="font-weight-bold m-0">
                    {{ vellos_quantity }}
                  </h2>
                </label>
                <p class="m-0 mb-n2">
                  <small class="d-block mb-n2 px-1">Vellos</small>
                  <small>Per Month</small>
                </p>
              </div>

              <div class="d-inline-block px-4">
                <label class="m-0">
                  <small class="d-inline-block font-weight-bold align-top mt-2">
                    {{ default_currency.symbol }}
                  </small>
                  <h2 class="d-inline-block font-weight-bold m-0">
                    {{ vellos_amount }}
                  </h2>
                </label>
                <p class="m-0 mb-n2">
                  <small class="d-block mb-n2">Per</small>
                  <small>Month</small>
                </p>
              </div>
              <p class="text-left pt-2">
                <small class="text-grey">
                  {{ vellos_billing }}
                </small>
              </p>
            </div>
            <p class="mt-4 border-bottom border-black border-8 pb-3 px-3 mx-n3">
              <b-link href="javascript:;" v-b-modal.addVellosForm>
                Change Subscription
                <b-img
                  class="float-right mr-2 mt-1"
                  src="~@/assets/img/open.svg"
                />
              </b-link>
            </p>
            <p
              class="mt-4 border-bottom border-black border-8 pb-3 px-3 mx-n3"
              @click="
                showConfirmBox('Vello', vello_subscription.subscription_id)
              "
            >
              <b-link href="javascript:;">
                Unsubscribe
                <b-img
                  class="float-right mr-2 mt-1"
                  src="~@/assets/img/open.svg"
                />
              </b-link>
            </p>
          </b-col>
        </b-row>
      </b-container>

      <add-vellos-modal
        v-if="vello_subscription"
        :subscription_id="vello_subscription.subscription_id"
        @done="reloadSubscriptions"
      />
    </b-overlay>
  </transition>
</template>

<script>
import AddVellosModal from '../../components/AddVellosModal'
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  name: 'SubscriptionDetails',
  components: { AddVellosModal },

  data() {
    return {
      loading: false,
      continue: false,
    }
  },

  computed: {
    ...mapState({
      profile: (state) => state.influencer.profile,
      influencer: (state) => state.subscription.influencer,
      vip_subscription: (state) => state.subscription.vip_subscription,
      vello_subscription: (state) => state.subscription.vello_subscription,
      default_currency: (state) => state.subscription.default_currency,
    }),

    influencer_uid: function () {
      if (this.influencer) {
        return this.influencer.influencer_uid
      }
      return ''
    },

    vip_amount: function () {
      if (this.vip_subscription) {
        return (
          this.vip_subscription.amount_paid * this.default_currency.rate
        ).toFixed(2)
      }
      return 0
    },

    vip_billing: function () {
      if (this.vip_subscription) {
        return this.vip_subscription.billing_desc
      }
      return ''
    },

    is_vip_canceled: function () {
      if (this.vip_subscription.stripe_sub_status === 'canceled') {
        return true
      }
      return false
    },

    vellos_amount: function () {
      if (this.vello_subscription) {
        return (
          this.vello_subscription.amount_paid * this.default_currency.rate
        ).toFixed(2)
      }
      return 0
    },

    vellos_quantity: function () {
      if (this.vello_subscription) {
        return this.vello_subscription.questions_count
      }
      return 0
    },

    vellos_billing: function () {
      if (this.vello_subscription) {
        return this.vello_subscription.billing_desc
      }
      return ''
    },

    isVipMonthly() {
      return !(
        this.vip_subscription &&
        this.vip_subscription.package.type === 'vip_yearly'
      )
    },
  },

  methods: {
    ...mapActions({
      getInfluencerSubscriptions: 'subscription/getInfluencerSubscriptions',
      getProfile: 'influencer/getProfile',
    }),
    ...mapMutations({
      clearSubscription: 'subscription/clearSubscription',
      clearProfile: 'influencer/clearProfile',
    }),

    convertDate(dateMillis) {
      return moment(dateMillis).format('MMM DD, YYYY')
    },

    async cancelSubscription(type, id) {
      let endpoint = `subscription/${id}`

      this.loading = true

      if (type === 'VIP') {
        endpoint = `influencer/${this.influencer_uid}/subscribe/vip`
      }

      await this.$api
        .delete(endpoint)
        .then(({ data }) => {
          this.loading = false
          this.showToast('success', data.message)

          // reload data
          this.getInfluencerSubscriptions(this.influencer_uid)
        })
        .catch((error) => {
          this.loading = false
          this.showToast('danger', error.response.data.message)
        })
    },

    async reloadSubscriptions() {
      await this.getInfluencerSubscriptions(this.$route.params.id)
    },

    showToast(type, message) {
      this.$bvToast.toast(message, {
        variant: type,
        noCloseButton: true,
        toaster: 'b-toaster-bottom-right',
      })
    },

    showConfirmBox(type, id = null) {
      this.$bvModal
        .msgBoxConfirm('Would you like to unsubscribe?', {
          id: 'confirmModal',
          title: type + ' Subscription',
          size: 'sm',
          buttonSize: 'sm',
          cancelVariant: 'secondary',
          okVariant: 'primary',
          okTitleHtml: '<span class="px-2">Yes</span>',
          cancelTitle: 'Cancel',
          footerClass: 'border-0 m-auto pb-4',
          bodyClass: 'text-center font-italic',
          headerClass: 'add-vello-icon',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.cancelSubscription(type, id)
          }
        })
    },
  },

  async created() {
    await this.getProfile(this.$route.params.id)
    await this.getInfluencerSubscriptions(this.$route.params.id)
  },

  destroyed() {
    this.clearSubscription()
    this.clearProfile()
  },
}
</script>

<style scoped></style>
